export default "__VITE_ASSET__BBJNp9Up__"